import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=520a0556&"
import script from "./date-input.vue?vue&type=script&lang=js&"
export * from "./date-input.vue?vue&type=script&lang=js&"
import style0 from "./date-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports